// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as N2f$Linear from "lumi-linear/lib/es6/src/N2f.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as M23f$Linear from "lumi-linear/lib/es6/src/M23f.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BoundingBox$Linear from "lumi-linear/lib/es6/src/BoundingBox.res.js";
import * as AxesModel$LumiDocuments from "./AxesModel.res.js";
import * as PlaceClass$LumiDocuments from "./PlaceClass.res.js";

import '../../../src/css/place-model.scss'
;

function transform(param, hmirror, vflip, param$1) {
  let pmsHeight = param[1];
  let pmsWidth = param[0];
  let transformAbs = param => {
    let y = param[1];
    let x = param[0];
    return [
      hmirror ? pmsWidth - x : x,
      vflip ? pmsHeight - y : y
    ];
  };
  let transformRel = param => {
    let y = param[1];
    let x = param[0];
    return [
      hmirror ? -1 * x : x,
      vflip ? -1 * y : y
    ];
  };
  return {
    a: transformAbs(param$1.a),
    b: transformAbs(param$1.b),
    c: transformAbs(param$1.c),
    d: transformAbs(param$1.d),
    up: Stdlib_Option.map(param$1.up, n2 => N2f$Linear.map(n2, transformRel)),
    width: param$1.width
  };
}

function warpAffine(qm, m23) {
  return {
    a: M23f$Linear.Mult.v2f(m23, qm.a),
    b: M23f$Linear.Mult.v2f(m23, qm.b),
    c: M23f$Linear.Mult.v2f(m23, qm.c),
    d: M23f$Linear.Mult.v2f(m23, qm.d),
    up: Stdlib_Option.map(qm.up, up => M23f$Linear.Mult.n2f(m23, up)),
    width: qm.width
  };
}

let jsonCodec = Jzon.object6(param => [
  param.a,
  param.b,
  param.c,
  param.d,
  param.up,
  param.width
], param => ({
  TAG: "Ok",
  _0: {
    a: param[0],
    b: param[1],
    c: param[2],
    d: param[3],
    up: param[4],
    width: param[5]
  }
}), Jzon.field("a", V2f$Linear.jsonCodec), Jzon.field("b", V2f$Linear.jsonCodec), Jzon.field("c", V2f$Linear.jsonCodec), Jzon.field("d", V2f$Linear.jsonCodec), Jzon.field("up", Jzon.nullable(N2f$Linear.jsonCodec)), Jzon.field("width", Jzon.float));

function getScale(param) {
  return V2f$Linear.length(V2f$Linear.minus(param.b, param.a)) / param.width;
}

function toAxesModel(param) {
  let d = param.d;
  let a = param.a;
  return {
    baseFront: V2f$Linear.plus(a, V2f$Linear.scale(V2f$Linear.minus(param.b, a), 0.5)),
    baseBack: V2f$Linear.plus(d, V2f$Linear.scale(V2f$Linear.minus(param.c, d), 0.5)),
    up: param.up,
    side: a,
    sideLength: param.width / 2
  };
}

function toPoly(qm, placeClass) {
  return AxesModel$LumiDocuments.toPoly(toAxesModel(qm), placeClass);
}

function toPolyQuadrilateral(quadModel, placeClass) {
  let up = quadModel.up;
  let d = quadModel.d;
  let c = quadModel.c;
  let b = quadModel.b;
  let a = quadModel.a;
  let topDownPoly = {
    topLeft: d,
    bottomLeft: a,
    bottomRight: b,
    topRight: c
  };
  if (up === undefined) {
    return topDownPoly;
  }
  let quadPoints = [
    a,
    b,
    c,
    d
  ];
  let height = PlaceClass$LumiDocuments.PlaceClass.quadrilateralModelHeight(placeClass);
  let pxPerM = getScale(quadModel);
  let h = V2f$Linear.scaleTo(N2f$Linear.asV2f(up), pxPerM * height);
  let boxPoints = quadPoints.concat(quadPoints.map(extra => V2f$Linear.plus(h, extra)));
  let mbOrientedBB = BoundingBox$Linear.orientedMinimumBoundingBox(boxPoints);
  if (mbOrientedBB === undefined) {
    return topDownPoly;
  }
  let match = BoundingBox$Linear.orientedBoundingBoxPoints(mbOrientedBB);
  return {
    topLeft: match[0],
    bottomLeft: match[3],
    bottomRight: match[2],
    topRight: match[1]
  };
}

function extraPoints(param) {
  return [
    param.a,
    param.b,
    param.c,
    param.d
  ];
}

function mainPoint(param) {
  return V2f$Linear.scale(V2f$Linear.plus(param.a, param.b), 0.5);
}

function scale(a, b, width) {
  return V2f$Linear.length(V2f$Linear.minus(b, a)) / width;
}

function QuadrilateralModel$Svg$Contour(props) {
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let className = LumiReact.classList([[
      "place-model-base",
      true
    ]].concat(classList));
  let points = props.points.map(param => param[0].toString() + `,` + param[1].toString()).join(" ");
  return JsxRuntime.jsx("polygon", {
    className: className,
    points: points,
    vectorEffect: "non-scaling-stroke"
  });
}

let Contour = {
  make: QuadrilateralModel$Svg$Contour
};

function QuadrilateralModel$Svg$Up(props) {
  let __classList = props.classList;
  let b = props.b;
  let a = props.a;
  let classList = __classList !== undefined ? __classList : [];
  let scale$1 = scale(a, b, props.width);
  let mainPoint = V2f$Linear.scale(V2f$Linear.plus(a, b), 0.5);
  let absoluteUp = V2f$Linear.plus(mainPoint, V2f$Linear.scaleTo(N2f$Linear.asV2f(props.up), scale$1 * 0.5));
  let className = LumiReact.classList([[
      "place-model-up",
      true
    ]].concat(classList));
  let match = V2f$Linear.mapToString(mainPoint);
  let match$1 = V2f$Linear.mapToString(absoluteUp);
  return JsxRuntime.jsx("line", {
    className: className,
    vectorEffect: "non-scaling-stroke",
    x1: match[0],
    x2: match$1[0],
    y1: match[1],
    y2: match$1[1]
  });
}

let Up = {
  make: QuadrilateralModel$Svg$Up
};

function QuadrilateralModel$Svg(props) {
  let __upClassList = props.upClassList;
  let __baseClassList = props.baseClassList;
  let match = props.quadModel;
  let width = match.width;
  let b = match.b;
  let a = match.a;
  let baseClassList = __baseClassList !== undefined ? __baseClassList : [];
  let upClassList = __upClassList !== undefined ? __upClassList : [];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(QuadrilateralModel$Svg$Contour, {
        points: [
          a,
          b,
          match.c,
          match.d,
          a
        ],
        classList: baseClassList
      }),
      LumiReact.renderOption(undefined, match.up, up => JsxRuntime.jsx(QuadrilateralModel$Svg$Up, {
        a: a,
        b: b,
        width: width,
        up: up,
        classList: upClassList
      }))
    ]
  });
}

let Svg = {
  scale: scale,
  Contour: Contour,
  Up: Up,
  make: QuadrilateralModel$Svg
};

export {
  transform,
  warpAffine,
  jsonCodec,
  getScale,
  toAxesModel,
  toPoly,
  toPolyQuadrilateral,
  extraPoints,
  mainPoint,
  Svg,
}
/*  Not a pure module */
